import React from 'react';
import { useRouter } from 'next/router';
import Breadcrumbs from '../breadcrumbs';
import { getBreadcrumbsData } from '../../helpers/breadcrumbs';
import Error from 'next/error';
import { FlyerDetailsViewData, FlyerItemViewData, MerchantViewData } from '../../helpers/flyers';
import { ErrorProps } from 'next/dist/pages/_error';
import FlyerItem from '../flyerItem';
import Footer from '../footer';
import Head from 'next/head';

export interface FlyerItemProps {
  merchant: MerchantViewData;
  flyerItemData: FlyerItemViewData;
  flyerData: FlyerDetailsViewData;
  error: ErrorProps;
}

export function FlyerItemPage({ flyerItemData, flyerData, merchant, error }: FlyerItemProps): JSX.Element {
  const router = useRouter();
  const location = router.query['location'] as string;

  if (error) {
    const { statusCode, title } = error;
    return <Error statusCode={statusCode} title={title} />;
  }

  return (
    <>
      <Head>
        <meta key="noindex" name="robots" content="noindex" />
      </Head>
      <Breadcrumbs breadcrumbs={getBreadcrumbsData(router)} />
      <FlyerItem item={flyerItemData} merchant={merchant} flyer={flyerData} location={location} />
      <Footer />
    </>
  );
}
